export var DragDropActionTypes;
(function (DragDropActionTypes) {
    DragDropActionTypes["BEGIN"] = "dragdrop.BEGIN";
    DragDropActionTypes["END"] = "dragdrop.END";
})(DragDropActionTypes || (DragDropActionTypes = {}));
